import { render, staticRenderFns } from "./SimpleAddress.vue?vue&type=template&id=ce66a49a&scoped=true"
import script from "./SimpleAddress.vue?vue&type=script&lang=js"
export * from "./SimpleAddress.vue?vue&type=script&lang=js"
import style0 from "./SimpleAddress.vue?vue&type=style&index=0&id=ce66a49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce66a49a",
  null
  
)

export default component.exports